import {Box, Stack, Typography} from "@mui/material";
import React, {useContext, useEffect} from "react";
import {useLocation} from "react-router";

import ScrollContext from "../../../utils/scrolling/ScrollContext";

type Props = {
	sectionNumber: number;
	exerciseNumber: number;
	exerciseId: number;
	title: string;
	metaIcon?: React.ReactNode;
};

const ExerciseTitle = (props: Props): JSX.Element => {
	const exerciseElemId = `subsection-${props.exerciseId}`;
	const location = useLocation();
	const elementId = location.hash.slice(1);

	const {scrollToElement} = useContext(ScrollContext);

	useEffect(() => {
		if (elementId && elementId === exerciseElemId) {
			scrollToElement(elementId);
		}
	}, [elementId, exerciseElemId, scrollToElement]);

	useEffect(() => {
		let timeout: undefined | ReturnType<typeof setTimeout>;
		if (elementId && elementId === exerciseElemId) {
			timeout = setTimeout(() => scrollToElement(elementId), 1200);
		}
		return () => {
			timeout && clearTimeout(timeout);
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [scrollToElement]);

	return (
		<Stack direction="row" spacing={1} sx={{alignItems: "flex-start", mb: 1}}>
			<Box
				component="a"
				sx={{position: "absolute", mt: -24}}
				id={exerciseElemId}
			/>

			<Typography variant="h5" style={{display: "flex"}}>
				<Typography
					variant="inherit"
					component="span"
					color="textSecondary"
					sx={{mr: 1}}
				>
					{`${props.sectionNumber}.${props.exerciseNumber}`}
				</Typography>
				{props.title}
			</Typography>

			{props.metaIcon}
		</Stack>
	);
};

export default ExerciseTitle;
